<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات محتوا"
        >
          <b-form @submit.prevent>
            <b-row>

              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <b-col md="12">
                    <b-form-group
                      label="نوع"
                      label-for="Type"
                    >
                      <v-select
                        v-model="Form.Type"
                        name="Type"
                        dir="rtl"
                        :reduce="x => x.value"
                        label="text"
                        input-id="Type"
                        :clearable="false"
                        :options="enums('ContentType')"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col cols="12">
                    <b-row
                      v-for="(item, index) in Form.ContentDetails"
                      :key="index"
                    >

                      <b-col md="10">
                        <b-form-group
                          label="عنوان"
                        >
                          <b-form-input
                            v-model="item.Title"
                            autocomplete="off"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col
                        md="2"
                        class="mb-1"
                        style="display: flex; align-items: flex-end;"
                      >
                        <template v-if="contentDetailsRemoveId !== index">
                          <b-button
                            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                            variant="outline-danger"
                            class="btn-icon rounded-circle"
                            @click="removeContentDetails(index)"
                          >
                            <feather-icon
                              icon="TrashIcon"
                            />
                          </b-button>
                        </template>
                        <template v-else>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            class="btn-icon rounded-circle"
                            variant="outline-primary"
                            @click="cancelContentDetails"
                          >
                            <feather-icon icon="XIcon" />
                          </b-button>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            class="btn-icon rounded-circle ml-1"
                            variant="outline-primary"
                            @click="confirmContentDetails"
                          >
                            <feather-icon icon="CheckIcon" />
                          </b-button>
                        </template>
                      </b-col>

                      <b-col cols="12">
                        <b-form-group
                          label="توضیحات"
                          label-for="Description"
                        >
                          <div class="form-label-group">
                            <b-form-textarea
                              id="Description"
                              v-model="item.Description"
                              name="Description"
                              autocomplete="off"
                              rows="3"
                              no-resize
                            />
                          </div>
                        </b-form-group>
                      </b-col>

                      <b-col cols="12">
                        <hr>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="gradient-info"
                      @click="addContentDetails"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        class="mr-25"
                      />
                      <span>افزودن</span>
                    </b-button>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

export default {
  name: 'ContentDetails',
  data() {
    return {
      Form: {
        Id: null,
        ContentDetails: [],
        Type: null,
      },
      loading: false,
      contentDetailsRemoveId: null,
    }
  },
  created() {
    if (typeof (this.$route.params.id) === 'number') {
      this.Form.Type = this.$route.params.id
      this.get()
    } else {
      this.addContentDetails()
    }
  },
  methods: {
    save() {
      let url = this.$api.content.add
      if (this.$route.params.id >= 0) {
        url = this.$api.content.update
      }

      this.loading = true
      this.$http.post(
        url, this.Form,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.content.get, {
          Type: this.Form.Type,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
    addContentDetails() {
      this.Form.ContentDetails.push({ Title: null, Description: null })
    },
    removeContentDetails(index) {
      this.contentDetailsRemoveId = index
    },
    confirmContentDetails() {
      this.Form.ContentDetails.splice(this.contentDetailsRemoveId, 1)
      this.contentDetailsRemoveId = null
    },
    cancelContentDetails() {
      this.contentDetailsRemoveId = null
    },
  },
}
</script>
